import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getSetupAuditTrailSourceNamePrefix } from '@api';

export const getCoreSetupAuditTrailSourceNamePrefixSlice = createGetAsyncSlice({
	name: 'CoreSetupAuditTrailSourceNamePrefix',
	receive: true,
	request: false,
	requestHandler: getSetupAuditTrailSourceNamePrefix,
	retainDataOnRequest: true
});
